import { useTranslate } from '@/utils/translate/translate-client'
import { getPrizeConfig, PrizeConfig } from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-prizes'

export const useGiveawayPrizes = (theatricalSlug: string): PrizeConfig | null => {
  const { t } = useTranslate('tickets')
  return getPrizeConfig(theatricalSlug, t)
}
